import { IStepLogLine } from "./stepLog.types";
import { tokens } from "@/app/application/theme";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { useTheme } from "@mui/material";

export const StepLogLineStatus: React.FunctionComponent<IStepLogLine> = (
	props,
) => {
	const { palette } = useTheme();
	const colors = tokens(palette.mode);
	if (props.logLine.ArchiveType !== "Status") return null;

	const statusIcon = props.logLine.Status ? (
		<CheckCircleIcon style={{ color: colors.greenAccent[500] }} />
	) : (
		<ErrorIcon style={{ color: colors.redAccent[500] }} />
	);

	return <div>{statusIcon}</div>;
};
